import React, { useEffect, useState } from 'react';
import { setNetworkStatus } from '../../../storage/networkStatus';

const NetworkStatus = () => {
  const [onlineStatus, setOnlineStatus] = useState(true);

  function hasNetwork(online) {
    // Update the DOM to reflect the current status
    setOnlineStatus(online);
    setNetworkStatus(online);
  }

  useEffect(() => {
    window.addEventListener('load', () => {
      hasNetwork(navigator.onLine);

      window.addEventListener('online', () => {
        // Set hasNetwork to online when they change to online.
        hasNetwork(true);
      });

      window.addEventListener('offline', () => {
        // Set hasNetwork to offline when they change to offline.
        hasNetwork(false);
      });
    });
  }, []);
  return <div style={{ display: 'none' }}>{onlineStatus ? 'Online' : 'Offline'}</div>;
};

export default NetworkStatus;
